import React, { Component } from 'react'

class Receive extends Component {
  constructor(props) {
    super(props)
    this.state = {
      load: 0,
    }
  }
  componentDidUpdate() {
    const { trigger } = this.props
    if (this.state.load <= 3) {
      this.setState({
        load: this.state.load + 1,
      })
      if (this.state.load >= 3) {
        this.props.triggerNextStep({ value: trigger, trigger })
      }
    }
  }

  render() {
    return <div className={`fthr-rcve `}>{this.props.children}</div>
  }
}
export default Receive
